export default __webpack_public_path__ + "static/media/all-school.70cf6adb.webp";